import Cookies from "js-cookie";
import * as React from "react";
import useAwaitedValue from "web-ui/components/useAwaitedValue";

import type { User } from "../api/v2";
import { apiV2 } from "../api/v2";
import { parseJwt } from "../util/auth";
import { Cookie } from "../util/cookies";

const UserContext = React.createContext<User | null | undefined>(undefined);

export const useUser = () => React.useContext(UserContext);

interface Props {
  children?: React.ReactNode;
}

const UserContextManager = ({ children }: Props) => {
  const user = useAwaitedValue(undefined, async () => {
    const jwt = Cookies.get(Cookie.Jwt);
    if (jwt === undefined) {
      return null;
    }
    const userId = Number(parseJwt(jwt).payload.sub);
    return apiV2.getUser(userId);
  }, []);
  return <UserContext.Provider value={user}>{children}</UserContext.Provider>;
};

export default UserContextManager;
